import React from 'react';
import { Spotlight } from './Spotlight';
export const Results = () => {
  return <section className="py-20 text-center px-4 relative overflow-hidden" style={{
    background: 'linear-gradient(to bottom, #FAF5EA 0%, #FAF5EA 4%, #EDE0BE 18%, #DDD0B0 38%, #DDD0B0 62%, #EDE0BE 82%, #FAF5EA 96%, #FAF5EA 100%)'
  }} data-id="element-395">
      <Spotlight className="opacity-70" data-id="element-396" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-397">
        {/* Elevated card */}
        <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-8 md:p-14 shadow-xl shadow-gold-900/10 border border-white/60" data-id="element-398">
          <h2 className="text-3xl md:text-5xl font-serif mb-6 text-neutral-900" data-id="element-399">
            Resultados REALES —{' '}
            <span className="metallic-gold-text italic" data-id="element-400">
              Sin filtros, sin Photoshop
            </span>
          </h2>
          <p className="text-xl md:text-2xl font-light text-neutral-700 mb-8" data-id="element-401">
            Cabello liso. Brillante. Manejable. Natural.
          </p>
          <div className="w-24 h-px bg-gold-300 mx-auto mb-8" data-id="element-402"></div>
          <p className="text-neutral-600 max-w-2xl mx-auto leading-relaxed" data-id="element-403">
            Esto es lo que ven nuestras clientas cuando salen de la silla — y lo
            que siguen viendo meses después. No prometemos magia. Prometemos
            ciencia orgánica aplicada con experiencia profesional.
          </p>
        </div>
      </div>
    </section>;
};